//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Fab from '@material-ui/core/Fab';

//Action
import * as myPostAction from '../action/myPostAction';
import * as myPostGoodUserAction from '../action/myPostGoodUserAction';
import * as lightboxAction from '../action/lightboxAction';
//Add
import moment from 'moment';
import ReactPaginate from 'react-paginate';
//Part
import MenuMyProfile from './MenuMyProfile';
//Dialog
import DialogMyPostGoodUser from './DialogMyPostGoodUser';
import DialogConfirm from './DialogConfirm';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import AddIcon from '@material-ui/icons/Add';


class Comp extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
      myPostGoodUserId: null,
      postDelId: null,
    }
	}

  componentDidMount() {
    document.title = '投稿 - パートナーズ';
    if ( ((new Date()) - this.props.my.post.datetime) > (600*1000) ) {
      this._myPostListGet(this.props.my.post.page);
    }
    if (this.props.history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  _myPostListGet(page) {
    this.props.myPostListGet(page);
  }

  _onPaging(page) {
    this._myPostListGet(page);
    window.scrollTo(0, 0);
  }



  _renderList(value, index) {
    let checkIcon;
    if (value.post_webmaster_check === 0) {
    	checkIcon = (<span className='blue_icon'>未申請</span>);
    }
    else if (value.post_webmaster_check === 1) {
    	checkIcon = (<span className='orange_icon'>公開中</span>);
    }
    else if (value.post_webmaster_check === 2) {
    	checkIcon = (<span className='purple_icon'>申請中</span>);
    }
    else if (value.post_webmaster_check === 3) {
    	checkIcon = (<span className='black_icon'>不承認</span>);
    }

    let listOpenIcon;
    if (value.post_list_open === 1) {
      listOpenIcon = (<span className='white_icon'>みんなの投稿&プロフ</span>);
    }
    else if (value.post_list_open === 2) {
      listOpenIcon = (<span className='white_icon'>みんなの投稿(異性のみ)&プロフ</span>);
    }
    else if (value.post_list_open === 0) {
      listOpenIcon = (<span className='white_icon'>プロフ</span>);
    }

    let goodCountNondisplayIcon;
    if (value.post_good_count_nondisplay === 1) {
      goodCountNondisplayIcon = (<span className='white_icon'>いいねの数を表示しない</span>);
    }

    return (
      <div key={index} style={{margin:'15px'}}>
        <Box className='postItem round12' boxShadow={2} style={{background:'#FFF'}}>
          <div style={{padding:'10px'}}>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
              <div>
                {
                  (moment(value.post_date).isValid()) && (
                    moment(value.post_date).format("YYYY年MM月DD日")
                  )
                }
              </div>
              <div>
                <IconButton
                  onClick={ () => this.props.history.push('/my/post/' + value.post_id) }
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  onClick={ () => this.setState({postDelDialogVisible: true, postDelId: value.post_id}) }
                >
                  <ClearIcon />
                </IconButton>
              </div>
            </div>

            {checkIcon} {listOpenIcon} {goodCountNondisplayIcon}
            <div style={{whiteSpace: 'pre-line'}}>
              {value.post_comment}
            </div>
          </div>

          {
						(Array.isArray(value.photo) === true) &&
						value.photo.map(
							(photoValue, photoIndex, arr) => this._renderImg(photoValue, photoIndex, arr)
						)
					}

          <div style={{padding:'10px'}}>
            <Button
              variant="outlined"
              color="primary"
              onClick={ () => this.props.myPostGoodUserListGet(value.post_id, 1, () => {}) }
            >
              <ThumbUpIcon style={{display:'inline-flex',verticalAlign:'middle'}}/>&nbsp;いいね&nbsp;{value.good_count}
            </Button>
          </div>

        </Box>
      </div>
    )
  }

  _renderImg(value, index, arr) {
    let photoList = arr.map(function(value, index) {
      return {src:arr[index].uri + "&W=600&H=600&blur=0&crop=0"};
    });

    if (((arr.length) % 2) === 1 & index === 0) {
			return (
				<div key={index} style={{display:'inline-block', position:'relative', width:'100%'}}>
          <div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >
            <img src={value.uri + "&W=600&H=300&blur=0&crop=1"} style={{width:"100%", height: "auto", boxSizing:'border-box'}} alt='' />
          </div>
				</div>
			);
		}
		else {
			return (
				<div key={index} style={{display:'inline-block', position:'relative', width:'50%'}}>
          <div
            style={{margin:'1px', position:'relative', cursor:'pointer'}}
            onClick={ () => this.props.lightboxOpen(photoList, index) }
          >
            <img src={value.uri + "&W=300&H=300&blur=0&crop=1"} style={{width:"100%", height: "auto", boxSizing:'border-box'}} alt='' />
        	</div>
				</div>
			);
		}
  }

  render() {
    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <MenuMyProfile />


        <div align='center' style={{margin:'5px',fontSize:'1.1em'}}>
          <Fab
            variant="extended"
            color="primary"
            onClick={ () => this.props.history.push('/my/post/add') }
          >
            <AddIcon />
            投稿を作成する
          </Fab>
        </div>
        {
          (this.props.my.post.datetime) && (
            <div id='my_post_block'>

              {
                (this.props.my.post.list.length > 0) ? (
                  <div>

                    <div
                      style={{
                        display:'flex',
                        flexDirection:'row',
                        alignItems:'center',
                        justifyContent: 'space-between',
                        margin: '10px',
                      }}
                    >
                      <div>
                        { this.props.my.post.count }件 (公開中 { this.props.my.post.countOpen }件)
                      </div>
                      <div>
                        <span style={{color:'#666'}}>ページ{this.props.my.post.page}</span>
                        <IconButton onClick={ () => this.props.myPostListGet(1) }>
                          <RefreshIcon />
                        </IconButton>
                      </div>
                    </div>

                    {
                      this.props.my.post.list.map((value, index) =>
                        this._renderList(value, index)
                      )
                    }

                    {
                      (Math.ceil(this.props.my.post.count / 10) > 1) && (
                        <div align='center' style={{margin:'15px'}}>
                          <ReactPaginate
                            breakLabel="…"
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={ (event) => this._onPaging((event.selected + 1)) }
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            pageCount={ Math.ceil(this.props.my.post.count / 10) }
                            renderOnZeroPageCount={null}
                            containerClassName={'pagingBlock'}
                            pageLinkClassName={'item'}
                            previousLinkClassName={'item'}
                            nextLinkClassName={'item'}
                            activeLinkClassName={'select'}
                            disabledClassName={'itemDisabled'}
                          />
                        </div>
                      )
                    }

                  </div>
                ) : (
                  <div style={{padding:'10px'}}>
                    <h2 align='center' style={{margin:'5px'}}>
                      投稿は作成されていません
                    </h2>
                    <div align='center' style={{margin:'5px'}}>
                        「日記」や「つぶやき」を<br />
                        <span
                        className='link'
                          onClick={ () => this.props.history.push('/community/post/') }
                        >
                          <u>みんなの投稿</u>
                        </span>
                        やプロフィールに掲載できます。<br />
                        日常の出来事を投稿してみましょう。<br />
                        プロフィールだけでは伝わりづらい<br />
                        魅力がきっと表現できます！
                    </div>
                  </div>
                )

              }
            </div>
          )
        }
        <DialogMyPostGoodUser />
        <DialogConfirm
          open={ (this.state.postDelId) ? true : false }
          title={'投稿の削除'}
          content={'投稿を1件削除してもいいですか？'}
          apply={ () => {
            this.props.myPostDel(this.state.postDelId);
            this.setState({postDelId: null});
          }}
          close={ () => this.setState({postDelId: null}) }
        />
      </div>

    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myPostAction,
    ...myPostGoodUserAction,
    ...lightboxAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
